// src/components/.../Catalogue Components/AddItemVariantModal.jsx
import React, { useEffect, useState } from "react";
import { Modal, Form } from "react-bootstrap";
import axios from "axios";
import { toast } from "react-toastify";

const AddItemVariantModal = ({
  show,
  onHide,
  itemId,
  itemName,
  item,
  userID ,
  config,
  onSuccess,
  baseUrl
}) => {
  console.log(itemId)
  const [form, setForm] = useState({
    price: "",
    variation: "",
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (show) {
      // Reset form whenever modal opens
      setForm({
        price: "",
        variation: "",
      });
    }
  }, [show, itemId]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!itemId) {
      toast.error("Item ID is missing");
      return;
    }
    if (!form.price || !form.variation) {
      toast.error("Price and variation are required");
      return;
    }

    const payload = {
      userid: String(userID),
      itemId: String(itemId),
      price: String(form.price),
      variation: String(form.variation),
      variationId: "", // as requested: keep empty, price/variation used only
    };

    try {
      setLoading(true);
      const res = await axios.post(
        `${baseUrl}/api/Order/v1.0/InsertCatalogItemVariant`,
        payload,
        config
      );

      if (res.data.responseCode === "00") {
        toast.success(res.data.responseMessage || "Variant added successfully");
        if (onSuccess) onSuccess(); // e.g. refresh catalogue
        onHide();
      } else {
        toast.error(res.data.responseMessage || "Failed to add variant");
      }
    } catch (err) {
      console.error(err);
      toast.error("Something went wrong while adding variant");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered size="md">
      <Form onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: "1rem" }}>
            Add Variant
            {itemName ? (
              <span
                style={{
                  fontSize: "0.8rem",
                  fontWeight: 500,
                  marginLeft: 6,
                  color: "#64748B",
                }}
              >
                · {itemName}
              </span>
            ) : null}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-3">
            <Form.Label>Variation Name / Label</Form.Label>
            <Form.Control
              type="text"
              name="variation"
              placeholder="Eg. Small, Medium, Large"
              value={form.variation}
              onChange={handleChange}
            />
          </div>
          <div className="mb-1">
            <Form.Label>Price</Form.Label>
            <Form.Control
              type="number"
              name="price"
              placeholder="Eg. 199"
              value={form.price}
              onChange={handleChange}
            />
          </div>
          <small className="text-muted">
            <strong>Note:</strong> <code>variationId</code> will be sent empty;
            backend will treat this as a new price variation for this item.
          </small>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-outline-secondary"
            onClick={onHide}
            disabled={loading}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="btn"
            style={{
              backgroundColor: "#01C37D",
              borderColor: "#01C37D",
              color: "#FFFFFF",
              minWidth: 120,
            }}
            disabled={loading}
          >
            {loading ? "Saving..." : "Save Variant"}
          </button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default AddItemVariantModal;
